module.exports = __webpack_public_path__ + "static/media/skrill.e212bbfd.svg";